import React from 'react';

import { useLegalDocumentsQuery } from 'generated/graphql';
import _ from 'lodash';
import {
  useLoading,
  baseTypes
} from 'modules';



export type TermSheet = 'Equity Term Sheet' | 'Convertible Debt Term Sheet' | 'SAFE Note Term Sheet';
export type LegalDocument = 'Certificate of Incorporation' | 'Stock Purchase Agreement' | 'Investors\' Rights Agreement' | 'Voting Agreement' | 'ROFR';
export type ProFormaTable = 'Pro Forma';



const termSheetTitles: TermSheet[] = ['Equity Term Sheet', 'Convertible Debt Term Sheet', 'SAFE Note Term Sheet'];
const legalDocumentTitles: LegalDocument[] = ['Certificate of Incorporation', 'Stock Purchase Agreement', 'Investors\' Rights Agreement', 'Voting Agreement', 'ROFR'];
const proFormaTableTitle: ProFormaTable[] = ['Pro Forma'];

function isTermSheet(title: string): title is TermSheet {
  return termSheetTitles.includes(title as TermSheet);
}

function isLegalDocument(title: string): title is LegalDocument {
  return legalDocumentTitles.includes(title as LegalDocument);
}

function isProFormaTable(title: string): title is ProFormaTable {
  return proFormaTableTitle.includes(title as ProFormaTable);
}



interface IData {
  termSheets: baseTypes.IApiFileData[];
  legalDocuments: baseTypes.IApiFileData[];
  proFormaTable: baseTypes.IApiFileData[];
}

export function useLegalDocuments() {
  const tuple = useLegalDocumentsQuery({
    variables: {
      extension: ['.doc', '.docx', '.xlsx']
    },
    fetchPolicy: 'no-cache'
  });
  const loading = useLoading([tuple]);



  const data = React.useMemo((): IData => ({
    termSheets: _.map(_.filter(tuple.data?.legalDocuments, doc => isTermSheet(doc.title)), (doc): baseTypes.IApiFileData => ({
      id: doc.id,
      key: doc.file.key,
      title: doc.title,
      extension: doc.extension,
      fileName: doc.file.fileName
    })),
    legalDocuments: _.map(_.filter(tuple.data?.legalDocuments, doc => isLegalDocument(doc.title)), (doc): baseTypes.IApiFileData => ({
      id: doc.id,
      key: doc.file.key,
      title: doc.title,
      extension: doc.extension,
      fileName: doc.file.fileName
    })),
    proFormaTable: _.map(_.filter(tuple.data?.legalDocuments, doc => isProFormaTable(doc.title)), (doc): baseTypes.IApiFileData => ({
      id: doc.id,
      key: doc.file.key,
      title: doc.title,
      extension: doc.extension,
      fileName: doc.file.fileName
    }))
  }), [tuple]);



  return {
    loading,
    data
  };
}
